import React from 'react';
import artificialIntelligenceImage from "../../assets/images/about-ai/artificial-intelligence.png";
import machineLearningImage from "../../assets/images/about-ai/machine-learning.png";
import generativeAiImage from "../../assets/images/about-ai/generative-ai.png";
import responsibleAiImage from "../../assets/images/about-ai/responsible-ai.png";

function About() {
  const aiConcepts = [
    {
      image: artificialIntelligenceImage,
      title: "Artificial Intelligence",
      text: "Understand how intelligent systems solve problems, automate work, and support better decisions."
    },
    {
      image: machineLearningImage,
      title: "Machine Learning",
      text: "Learn how models identify patterns from data and improve outcomes through training and evaluation."
    },
    {
      image: generativeAiImage,
      title: "Generative AI",
      text: "Explore how AI creates text, summaries, code, images, and business-ready content from prompts."
    },
    {
      image: responsibleAiImage,
      title: "Responsible AI",
      text: "Build awareness of data privacy, bias, accuracy, human review, and ethical use of AI tools."
    }
  ];
  const useCases = [
    "Chatbots and virtual assistants",
    "Document summarization",
    "Predictive analytics",
    "Fraud detection",
    "Recommendation systems",
    "AI-assisted testing"
  ];

  return (
    <section id="about" className="about">
      <div className="about-shell">
        <div className="about-intro-grid">
          <div className="about-copy">
            <h1>Smart Software. AI Concepts. Future-Ready Skills.</h1>
            <p>
              Inventra Labs is committed to transforming ideas into future-ready
              technology. Founded in 2025, we deliver intelligent, scalable software
              solutions, practical assessments, and clear AI learning content to help
              businesses and learners grow.
            </p>
          </div>

          <div className="section-heading">
            <p className="eyebrow">AI Concepts</p>
            <h2>Learn AI from basics to real-world application</h2>
            <p>
              Artificial Intelligence is changing how teams build products, automate
              workflows, analyze data, and make decisions.
            </p>
          </div>
        </div>

        <div className="ai-board">
          <div className="ai-card-grid">
          {aiConcepts.map((concept) => (
            <article className="ai-card" key={concept.title}>
              <img src={concept.image} alt="" className="ai-card-logo" />
              <h3>{concept.title}</h3>
              <p>{concept.text}</p>
            </article>
          ))}
          </div>
        </div>

        <div className="ai-details-grid">
          <div className="ai-panel">
            <h3>What You Will Learn</h3>
            <ul>
              <li>Difference between AI, ML, Deep Learning, and Data Science</li>
              <li>How AI models are trained, tested, deployed, and monitored</li>
              <li>Prompt engineering and effective use of AI tools</li>
              <li>AI use cases across education, finance, healthcare, and business</li>
            </ul>
          </div>

          <div className="ai-panel">
            <h3>Practical Use Cases</h3>
            <div className="use-case-list">
              {useCases.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="responsible-ai">
          <strong>Responsible AI matters.</strong>
          <span>
            We promote AI learning that values privacy, fairness, validation,
            transparency, and human oversight for important decisions.
          </span>
        </div>
      </div>
    </section>
  );
}

export default About;
